import Vue from 'vue';
import VueAxios from 'vue-axios'
import Cleave from 'vue-cleave-component';
import GlobalScope from './plugin/global-scope';
import * as filters from './filters';
import bugsnagVue from '@bugsnag/plugin-vue';
import Tooltip from "./directive/tooltip";
import {http, api} from "../../common/common";
import VueLazy from "./directive/lazy";

// Bugsnag
if (window.Bugsnag) {
    window.Bugsnag.use(bugsnagVue, Vue);
}

// Global Scope
GlobalScope(Vue);

// Tooltips
Tooltip(Vue);
VueLazy(Vue);

// Axios
Vue.use(VueAxios, {
    http: http,
    api: api,
});

// Cleave component - https://github.com/ankurk91/vue-cleave-component
Vue.use(Cleave);

// Global Filters
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
});

export default Vue;